import { render, staticRenderFns } from "./infinite.vue?vue&type=template&id=b4cc23f0"
import script from "./infinite.vue?vue&type=script&lang=js"
export * from "./infinite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports